import { useRef, useEffect } from 'preact/hooks'

/**
 * Compare previous value to current value
 */
export function usePrevious(value) {
	const ref = useRef()

	useEffect(() => {
		ref.current = value
	}, [value])

	return ref.current
}
